import Crud from '../views/Agency/Crud'
import Entity from '../views/Agency/Add'

let routes = {
    path: '/centrals',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/centrals/add',
            name: 'NewAgency',
            component: Entity,
            meta: {
                pageTitle: 'Agência',
                breadcrumb: [
                    {
                        text: 'Adicionar Agência',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/centrals/edit/:id?',
            name: 'EditAgency',
            component: Entity,
            meta: {
                pageTitle: 'Agência',
                breadcrumb: [
                    {
                        text: 'Editar Agência',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/centrals',
            name: 'list-centrals',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Agências',
                breadcrumb: [
                    {
                        text: 'Agências',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
